var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreedActionsNotStranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00262046 0.86687C0.0403274 0.338304 0.475127 -0.0476712 0.973774 0.00476983C0.973774 0.00476983 7.12613 0.651793 11.0683 1.06638C15.0104 1.48096 21.1628 2.12798 21.1628 2.12798C21.6614 2.18042 22.0351 2.65142 21.9974 3.17999C21.9597 3.70855 21.5249 4.09453 21.0262 4.04209C21.0262 4.04209 14.8739 3.39507 10.9317 2.98048C6.98958 2.5659 0.837225 1.91888 0.837225 1.91888C0.338579 1.86644 -0.0350865 1.39544 0.00262046 0.86687Z",
    fill: "#204BE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.802L0.973774 6.95791C0.475128 6.90547 0.0403274 7.29145 0.00262046 7.82001C-0.0350865 8.34858 0.338579 8.81958 0.837225 8.87202L9 9.73047V7.802Z",
    fill: "#009C8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.1511L21.0262 10.9952C21.5249 11.0477 21.9597 10.6617 21.9974 10.1331C22.0351 9.60456 21.6614 9.13356 21.1628 9.08112L13 8.22267V10.1511Z",
    fill: "#009C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreedActionsNotStranding);
export default __webpack_public_path__ + "static/media/agreed-actions-not-stranding.2e318728e00c11feacb30c340ff5f948.svg";
export { ForwardRef as ReactComponent };